<template>
    <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
        <div v-if="$gate.isBuyer()">
            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>Acquired Lots</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section class="content">
                <div class="col-md-12">
                    <div class="row">
                        <pagination
                            :pagination="pagination"
                            @prev="getWonLots(pagination.prevPageUrl)"
                            @next="getWonLots(pagination.nextPageUrl)"
                        ></pagination>
                    </div>
                    <br>
                        <div v-if="my_lots.length > 0" class="row">
                            <div class="col-sm-4 float-left" v-for="lot in my_lots" :key="lot.id">
                                <div class="card card-primary card-outline">
                                    <div class="card-body">
                                        <h3>{{lot.auction_id}}</h3>
                                        <b>Sold Lots: </b> {{lot.lots_sold}}
                                        <br>
                                        <b>Total Lots: </b>{{lot.total_lots}}
                                        <br>
                                        <br>
                                        <button class="btn btn-success" style="border-radius: 20px; width:100%;" @click="details(lot)"><b>View</b></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="row">
                            <h3>Hmmm... No data perhaps?</h3>
                            <img src="../images/nodata.svg" alt="Hmmm... No data perhaps?">
                        </div>
                    <br>
                    <div class="row">
                        <pagination
                            :pagination="pagination"
                            @prev="getWonLots(pagination.prevPageUrl)"
                            @next="getWonLots(pagination.nextPageUrl)"
                        ></pagination>
                    </div>
                </div>
            </section>

            <br>
            <br>
        </div>
        <div v-if="!$gate.isBuyer()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
import Pagination from '../pagination.vue';

export default {
    components: { pagination: Pagination },

    mounted() {
        console.log('Component mounted.')
    },

    created(){
        this.getWonLots();
    },

    data(){
        return {
            my_lots: [],
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
            },
        }
    },

    methods: {
        configPagination(data){
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        getWonLots(url = "/api/getWonAuctions"){
            axios.post(url, { buyer_id: this.$userId })
                .then(response => {
                    this.my_lots = response.data.data.data;
                    this.configPagination(response.data.data);
                })
                .catch(error => {
                    console.error("Error fetching won lots:", error);
                    // Handle error (e.g., show error message to user)
                });
        },

        lotDetails(id){
            window.open('/home/buyer/lot-details/'+id)
        },

        details(lot){
            this.$router.push("/home/buyer/lot-ticket/"+lot.id);
        }
    }
}
</script>
